/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Start_Page_HeadlineInputs */

const en_start_page_headline = /** @type {(inputs: Start_Page_HeadlineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Strength and mobility, in the studio or online`)
};

const pl_start_page_headline = /** @type {(inputs: Start_Page_HeadlineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trening siłowy i mobilność, w studiu albo online`)
};

/**
* | output |
* | --- |
* | "Strength and mobility, in the studio or online" |
*
* @param {Start_Page_HeadlineInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const start_page_headline = /** @type {((inputs?: Start_Page_HeadlineInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Start_Page_HeadlineInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_start_page_headline(inputs)
	return en_start_page_headline(inputs)
});